// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"85502c1c02fd7ccc48c0","655":"519ba20f6bd544791bd7"}[chunkId] + ".js";
};